<!-- A person's name in the program: a router-link for this site's pages (e.g.
     http://vizbi.org/2026/People#Paola_Perin → /2026/People#Paola_Perin), a plain link for
     external sites. www.vizbi.org is the legacy server (old blog, posters): it stays external. -->
<template>
  <router-link v-if="internalPath" :to="internalPath"><slot /></router-link>
  <a v-else :href="url"><slot /></a>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({url: {type: String, default: ""}});

const SITE_HOSTS = ["vizbi.org"];

function getInternalPath(url) {
  const text = String(url || "").trim();
  if (text.startsWith("/") && !text.startsWith("//")) return text;
  try {
    const parsed = new URL(text);
    const isSite = SITE_HOSTS.includes(parsed.host) || parsed.host === window.location.host;
    return isSite ? `${parsed.pathname}${parsed.search}${parsed.hash}` : "";
  } catch {
    return "";
  }
}

const internalPath = computed(() => getInternalPath(props.url));
</script>
